import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AsahiNavbarComponent } from '../asahi-navbar/asahi-navbar.component';
import { AsahiFooterComponent } from '../asahi-footer/asahi-footer.component';
import { ClevertapService } from '../../../service/clevertap.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-asahi-success-page',
  imports: [AsahiFooterComponent, AsahiNavbarComponent, TranslatePipe, CommonModule],
  templateUrl: './asahi-success-page.component.html',
  styleUrl: './asahi-success-page.component.scss'
})
export class AsahiSuccessPageComponent {
  constructor(private clevertapService: ClevertapService) { }
  ngOnInit(): void {
    const productType = 'income_protection';

    // Adding a delay to ensure the campaign trigger catch is reliable after route change
    setTimeout(() => {
      this.clevertapService.trackEvent('explored_after_submission', {
        product_type: productType
      });
      // Show notification prompt fallback if not already subscribed
      this.clevertapService.showNotificationPrompt();
    }, 1000);
  }
  showBottomSheet = true;
  closeBottomSheet(event: MouseEvent) {
    this.showBottomSheet = false;
  }
}
